import httpClient from '../httpClient';

const getAllByValidation = async (id) => {
  return await httpClient.get(
    `/term_document_contract_document_history/?filter[validacion_documentos_contractuales]=${id}`,
  );
};

export { getAllByValidation };
